import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import CountryPage from "./components/CountryPage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const App = () => {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Layout />} />
        <Route path="/country/:country" element={<CountryPage />} />
      </Routes>
      <Footer/>
    </div>
  );
};

export default App;
